<template>
    <div v-if="display">
        <div class="container header-margin ">
            
            <div class="text-center p-2 wrap-text">
                <h2 class="text-color main_title">{{ $t('auth.signupTitleAube') }}</h2>
            </div>
            
            <div class="tab-content p-2">
                <div class="row no-gutters text-center navigation">
                    <div id="box1" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-center">{{ $t('auth.navigationAube.title1') }}</p></div>
                    <div id="box2" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-center">{{ $t('auth.navigationAube.title2') }}</p></div>
                    <div id="box3" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-center">{{ $t('auth.navigationAube.title3') }}</p></div>
                    <div id="box4" class="col-md-3 col-sm-3 col-xs-5 box-area active-color-box"><p class="text-center">{{ $t('auth.navigationAube.title4') }}</p></div>
                </div>

                <div>
                    <div class="text-center p-2">
                        <h3 class="text-color sub_title">{{ $t('auth.userProfileComplete.titleAube') }}</h3>
                    </div>

                    <div class="pt-2 pb-5 pre">
                        <p style="margin-left: 34px;">{{ $t('auth.userProfileComplete.textAube') }}</p>
                    </div>

                    <div class="text-center pt-2">
                        <button type="button" @click="handleOnSubmit" class="btn btn-primary mr-2">{{ $t('auth.userProfileComplete.btnAube') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import languageService from "../../../services/LanguageService";
    import UserService from '../../../services/UserService';
    import RecaptchaMixin from '../../../utils/RecaptchaMixin';

    export default {
        name: 'registration-module',
        mixins: [RecaptchaMixin],
        data() {
            return {
                display: false,
                prevRoute: null
            }
        },
        created() {
            this.fetchUserData();
        },
        methods: {
            async handleOnSubmit() {
                this.language = languageService.getCurrentLanguageCode();
                this.formData = JSON.parse(sessionStorage.formData);
                this.formData.member = false;
                const recaptchaToken = await this.recaptchaGetKey();
                try {
                    const result = await UserService.loginCreateUser(
                        this.formData.account,
                        this.formData.password,
                        this.formData.member,
                        this.language,
                        recaptchaToken
                    );
                    sessionStorage.removeItem('formData')
                    UserService.setLogin(result.data);
                    this.$router.push('/');
                } catch (error) {
                    error.response.data.errors.forEach(error => {
                        if (error.field) {
                            this.errors[error.field] = error.message[0];
                        }
                    });
                }
            },
            async fetchUserData() {
                try {
                    this.formData = JSON.parse(sessionStorage.formData);
                    const result = await UserService.getUserConfirmDataByMail(this.formData);
                    if(result.data.member_type_id ==1200 || 
                        result.data.member_type_id == 1210 || 
                        result.data.member_type_id == 1220 
                    ){
                        location.href='https://www.force-club.com/login';
                    }else{
                        this.display = true
                        this.email = result.data.email;
                        if(sessionStorage.formData){
                            this.formData = JSON.parse(sessionStorage.formData);
                        }
                        this.maxHeight();
                    }
                } catch (e) {
                    this.$router.push('/');
                }
            },
            async maxHeight() {
                setTimeout(() => {
                    let box1 = document.getElementById('box1').clientHeight
                    let box2 = document.getElementById('box2').clientHeight
                    let box3 = document.getElementById('box3').clientHeight
                    let box4 = document.getElementById('box4').clientHeight
                    let maxHeight = Math.max(box1,box2,box3,box4);
                    document.getElementById('box1').style.height = maxHeight+'px'
                    document.getElementById('box2').style.height = maxHeight+'px'
                    document.getElementById('box3').style.height = maxHeight+'px'
                    document.getElementById('box4').style.height = maxHeight+'px'
                 }, 1000);
            },                      
        }
    }
</script>
<style scoped>
    .main_title{
        margin-bottom:15px;
    }
    .sub_title{
        margin-bottom:15px;
    }
    .header-margin{
        top:250px;
    }
    .pre {
        white-space: pre-wrap;
    }
    .active-color-box{
        background: #451493;
        border-color:#451493;
    }
    .non-active-color-box{
        background: #bdbebd; 
    }
    /*ボタンのスタイル*/
    .btn-primary{
        background: #451493!important;
        border-color: #451493!important;
        width: 200px;
    }
    .btn-primary:hover {
        color: #fff !important;
        background-color: #350f71 !important;
        border-color: #300e66 !important;
    }
    .text{
        font-size: 25px;
    }
    .wrap-text{
        padding-bottom: 20px;
    }
    .box-area {
        padding: 0.5em 0em;
        width:50%;
        color: #FFF;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #box2,#box3,#box4{
        outline: 1px solid #FFF;
    }
    .box-area p {
        margin-top: 2px;
        margin-bottom: 2px;
        padding-top: 1px;
    }
    .navigation{
        padding-top:15px;
        padding-bottom:40px;
    }
    .text-color{
        color: #451493;
    }
    /*スマホ用css*/
    @media screen and (max-width: 479px) {
        .box-area[data-v-40212d93] {
            height: 90px;
        }
        .form-group{
            padding-left: 0px;
        }
        .header-margin{
            padding-left: 0px;
            padding-right: 0px;
        }
        .main_title{
            font-size: 1.575rem;
            margin-bottom: 0px;
        }
        .sub_title{
            font-size: 1.3rem;
            margin-bottom: 0px;
        }
        .navigation{
            padding-top: 0px;
            padding-bottom:15px;
        }
    }
</style>
